import AppImage from '@/components/ui/AppImage';

interface BulkCustomer {
  name: string;
  logo: string;
  alt: string;
}

const bulkCustomers: BulkCustomer[] = [
  {
    name: 'Prestige Estates',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1204870c8-1766601708936.png",
    alt: 'Prestige Estates luxury residential complex logo with modern architecture'
  },
  {
    name: 'DLF Homes',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_174f716d0-1768819129535.png",
    alt: 'DLF Homes premium housing society logo with glass building facade'
  },
  {
    name: 'Godrej Properties',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1c84505a5-1768483886715.png",
    alt: 'Godrej Properties corporate office building with modern design'
  },
  {
    name: 'Brigade Group',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15cdf72ac-1768016671265.png",
    alt: 'Brigade Group residential towers with contemporary architecture'
  },
  {
    name: 'Sobha Limited',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a81a18bd-1766952011737.png",
    alt: 'Sobha Limited luxury apartment complex with landscaped gardens'
  },
  {
    name: 'Mahindra Lifespaces',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1c429a9cb-1764690171853.png",
    alt: 'Mahindra Lifespaces integrated township with modern amenities'
  }
];

export default function BulkCustomerLogos() {
  return (
    <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-heading font-bold text-gray-900 mb-2">
          Designed for Large Residential Communities
        </h3>
        <p className="text-sm text-gray-600">
          ParkPing is built to support large housing societies, gated communities, and organizational campuses.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
        {bulkCustomers.map((customer, index) => (
          <div
            key={index}
            className="bg-white rounded-lg p-5 flex items-center justify-center hover:shadow-md transition-all duration-300 hover:-translate-y-1 border border-gray-100 hover:border-[#42AF47]/30"
          >
            <div className="relative w-full h-16 grayscale hover:grayscale-0 transition-all duration-300">
              <AppImage
                src={customer.logo}
                alt={customer.alt}
                className="object-contain"
                fill
                sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 16vw"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <p className="text-sm text-gray-600">
          <span className="font-semibold text-[#42AF47]">Built for scale</span> from bulk customers
        </p>
      </div>
    </div>
  );
}